import createTypedReducer, { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

interface GAIAProductListState {
    isLoadMore: boolean;
    page?: number;
}
const initialState: GAIAProductListState = { isLoadMore: false };

const reducer = createTypedReducerWithImmer(initialState, {
    "Custom/ProductList/BeginLoadMore": (draft: Draft<GAIAProductListState>) => {
        draft.isLoadMore = true;
    },
    "Custom/ProductList/CompleteLoadMore": (draft: Draft<GAIAProductListState>) => {
        draft.isLoadMore = false;
    },
    "Custom/ProductList/SetPage": (draft: Draft<GAIAProductListState>, action: { page?: number }) => {
        draft.page = action.page;
    },
});

(reducers as any).customProductListReducer = reducer;

export type CustomProductListState = {
    customProductListReducer: GAIAProductListState;
} & ApplicationState;

type Reducers = {
    customProductListReducer: typeof reducer;
};

export type CustomProductListActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
